const Checkbox = {
  baseStyle: {
    control: {
      border: '2px solid',
      borderColor: 'border.strong',
      bg: 'surface.default',
      borderRadius: 'sm',
      _hover: { borderColor: 'accent.default' },
      _focusVisible: { boxShadow: 'outline', borderColor: 'accent.default' },
      _checked: {
        bg: 'accent.default',
        borderColor: 'accent.default',
        color: 'white',
        _hover: { bg: 'accent.hover', borderColor: 'accent.hover' },
      },
    },
  },
};

export default Checkbox;
